import { Link } from "react-router-dom";
import { useCompanyInfo } from "../../data/company";

/**
 * Dark contact CTA panel from Airon.html design.
 * Reusable across home, services, about and other inner pages.
 */
export function ContactCTA({
  title,
  highlight,
  description,
  primary = { label: "Be om tilbud", to: "/kontakt" },
  secondary = { label: "Bestill befaring", to: "/kontakt" },
}) {
  const company = useCompanyInfo();
  const headingLead = title || "Trenger du friskere luft";
  const headingTail = highlight || "der du jobber eller bor?";
  const body =
    description ||
    "Ring, send mail, eller bestill befaring. Du snakker alltid med noen som vet hva vi driver med.";

  return (
    <section className="contact-cta" id="kontakt">
      <div className="wrap">
        <div className="cta-grid">
          <div>
            <h2>
              {headingLead} <em>{headingTail}</em>
            </h2>
            <p>{body}</p>
            <div className="cta-actions">
              {primary ? (
                <Link to={primary.to} className="btn">
                  {primary.label} <span className="arr">→</span>
                </Link>
              ) : null}
              {secondary ? (
                <Link to={secondary.to} className="btn ghost">
                  {secondary.label}
                </Link>
              ) : null}
            </div>
          </div>
          <div className="cta-card">
            <h5>Direkte kontakt</h5>
            <div className="cta-row">
              <div className="ico">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92V21a1 1 0 0 1-1.1 1 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 3.2 4.1 1 1 0 0 1 4.2 3H8.3a1 1 0 0 1 1 .75 12.84 12.84 0 0 0 .7 2.8 1 1 0 0 1-.23 1.06l-1.73 1.73a16 16 0 0 0 6 6l1.73-1.73a1 1 0 0 1 1.06-.23 12.84 12.84 0 0 0 2.8.7 1 1 0 0 1 .75 1Z" />
                </svg>
              </div>
              <div>
                <div className="k">Telefon</div>
                <div className="v">
                  <a href={`tel:${company.phone.tel}`}>{company.phone.display}</a>
                </div>
              </div>
            </div>
            <div className="cta-row">
              <div className="ico">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="5" width="18" height="14" rx="2" />
                  <path d="M3 7l9 6 9-6" />
                </svg>
              </div>
              <div>
                <div className="k">E-post</div>
                <div className="v">
                  <a href={`mailto:${company.email}`}>{company.email}</a>
                </div>
              </div>
            </div>
            <div className="cta-row">
              <div className="ico">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-8 8-14a8 8 0 1 0-16 0c0 6 8 14 8 14Z" />
                  <circle cx="12" cy="8" r="3" />
                </svg>
              </div>
              <div>
                <div className="k">Besøk</div>
                <div className="v">{company.address.full}</div>
              </div>
            </div>
            <div className="cta-row">
              <div className="ico">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="16" rx="2" />
                  <path d="M8 2v4M16 2v4M3 10h18" />
                </svg>
              </div>
              <div>
                <div className="k">Åpningstider</div>
                <div className="v" style={{ lineHeight: 1.5 }}>
                  {company.hours.lines.map((h, i) => (
                    <span key={i} style={{ display: "block" }}>
                      {h.day} · {h.time}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactCTA;
